var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-area-wrapper"},[_c('div',{staticClass:"banner-area text-center",style:({ backgroundImage: 'url(' + _vm.getBanner(_vm.banner) + ')' })})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00e07979","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/bannerv2.vue
// module id = ifqL
// module chunks = 0